export default "__VITE_ASSET__snvGAUeL__"